export default [
  {
    name: 'questionnaireManage',
    path: '/questionnaireManage',
    component: () => import('@/views/questionnaireManage/index.vue'),
    meta: {
      title: '问卷模板管理'
    }
  }
];
